export default __webpack_public_path__ + "static/media/undraw_in_progress_ql66.8bd443d3.svg";